"use client";

import { POST_BY_SLUG_QUERYResult } from "@/sanity/types";
import { useTheme } from "@/contexts/ThemeContext";

type CategoriesProps = {
  categories: NonNullable<POST_BY_SLUG_QUERYResult>["categories"];
};

export function Categories({ categories }: CategoriesProps) {
  const { themeColors } = useTheme();

  return (
    <div className="flex gap-2 flex-wrap">
      {categories.map((category) => (
        <span
          key={category._id}
          style={{ backgroundColor: themeColors.tagBackgroundColor }}
          className={`rounded-[10px] px-[15px] py-[6px] leading-none whitespace-nowrap text-xsmall border ${themeColors.tagBorderColor} ${themeColors.tagTextColor}`}
        >
          {category.title}
        </span>
      ))}
    </div>
  );
}
